/*
  SOLCOZM — Collection Motion A 2.0 (sezione Shopify)
  Dati letti dal markup Liquid (data-*): titolo, prezzo già formattato da Shopify nella valuta del mercato,
  link localizzato, proporzioni del capo, presenza del retro. Nessun dato scritto a mano.
  - Movimento: slot per distanza dal capo attivo, onda (ritardo per livello), fluttuazione leggera.
  - Autoplay lento: pausa fuori schermo, scheda nascosta, hover/focus, trascinamento, pausa utente,
    prefers-reduced-motion (non parte da solo) o impostazione disattivata.
  - Swipe orizzontale con touch-action: pan-y; frecce ←/→; Fronte/Retro con reset al cambio capo.
  - Theme editor: shopify:section:load/unload, shopify:block:select/deselect.
*/
(function () {
  'use strict';

  var reduceMQ = window.matchMedia('(prefers-reduced-motion: reduce)');
  var mobileMQ = window.matchMedia('(max-width: 749px)');
  var tabletMQ = window.matchMedia('(min-width: 750px) and (max-width: 1024px) and (orientation: portrait)');

  var SLOTS = {
    desktop: { fit: 0.97, slots: [{ x: 0, s: 1, o: 1 }, { x: 0.265, s: 0.5, o: 0.96 }, { x: 0.415, s: 0.34, o: 0.5 }, { x: 0.52, s: 0.26, o: 0 }] },
    tablet: { fit: 0.97, slots: [{ x: 0, s: 1, o: 1 }, { x: 0.35, s: 0.46, o: 0.92 }, { x: 0.47, s: 0.3, o: 0.45 }, { x: 0.56, s: 0.22, o: 0 }] },
    mobile: { fit: 0.97, slots: [{ x: 0, s: 1, o: 1 }, { x: 0.47, s: 0.44, o: 0.72 }, { x: 0.7, s: 0.3, o: 0 }, { x: 0.8, s: 0.24, o: 0 }] }
  };
  var ICON_PAUSE = '<svg viewBox="0 0 14 14" aria-hidden="true"><rect x="3" y="2" width="2.4" height="10" fill="currentColor"/><rect x="8.6" y="2" width="2.4" height="10" fill="currentColor"/></svg>';
  var ICON_PLAY = '<svg viewBox="0 0 14 14" aria-hidden="true"><path d="M4 2.2v9.6L11.5 7z" fill="currentColor"/></svg>';

  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function listen(mq, fn) { if (mq.addEventListener) mq.addEventListener('change', fn); else mq.addListener(fn); }

  function Motion(root) {
    var self = this;
    this.root = root;
    this.stage = root.querySelector('.sc-cm__stage');
    this.items = Array.prototype.slice.call(root.querySelectorAll('.sc-cm__item'));
    this.n = this.items.length;
    if (!this.stage || this.n < 2) return; /* con un solo capo resta l'elenco statico */
    this.data = this.items.map(function (a) {
      return {
        ratio: parseFloat(a.getAttribute('data-ratio')) || 0.8,
        height: parseFloat(a.getAttribute('data-height')) || 0.84,
        title: a.getAttribute('data-title') || '',
        meta: a.getAttribute('data-meta') || '',
        price: a.getAttribute('data-price') || '',
        url: a.getAttribute('href'),
        back: a.getAttribute('data-back') === 'true'
      };
    });
    this.L = function (k) { return root.getAttribute('data-l-' + k) || ''; };
    this.info = root.querySelector('.sc-cm__info');
    this.countEls = root.querySelectorAll('[data-cm-count]');
    this.live = root.querySelector('[data-cm-live]');
    this.playBtn = root.querySelector('[data-cm-play]');
    this.progress = root.querySelector('.sc-cm__progress span');
    this.sides = root.querySelector('.sc-cm__sides');
    this.sideBtns = this.sides ? this.sides.querySelectorAll('button') : [];
    this.interval = parseInt(root.getAttribute('data-interval'), 10) || 7000;
    this.current = 0;
    this.side = 'front';
    this.visible = false;
    this.hover = false;
    this.focusWithin = false;
    this.dragging = false;
    this.editorHold = false;
    this.userPaused = reduceMQ.matches || root.getAttribute('data-autoplay') !== 'true';
    this.timer = null;
    this.remaining = this.interval;
    this.startedAt = 0;
    this.bind();
    this.layout();
    this.render(true);
    root.classList.add('is-ready');
    this.schedule();
    root.__scCM = this;
  }

  Motion.prototype.bind = function () {
    var self = this, r = this.root, ac = this.ac = ('AbortController' in window) ? new AbortController() : null;
    var opt = ac ? { signal: ac.signal } : false;
    var on = function (el, ev, fn, o) { el.addEventListener(ev, fn, o || opt); };

    r.querySelectorAll('[data-cm-prev]').forEach(function (b) { on(b, 'click', function () { self.go(self.current - 1, true); }); });
    r.querySelectorAll('[data-cm-next]').forEach(function (b) { on(b, 'click', function () { self.go(self.current + 1, true); }); });
    if (this.playBtn) on(this.playBtn, 'click', function () { self.userPaused = !self.userPaused; self.restartTimer(); });

    this.items.forEach(function (a, i) {
      on(a, 'click', function (e) {
        if (self.suppressClick) { e.preventDefault(); return; }
        if (i !== self.current) { e.preventDefault(); self.go(i, true); }
        /* il capo attivo apre la scheda prodotto (link reale) */
      });
    });
    Array.prototype.forEach.call(this.sideBtns, function (b) {
      on(b, 'click', function () {
        var s = b.getAttribute('data-side');
        if (s === self.side) return;
        self.side = s; self.renderSide(); self.restartTimer();
        if (self.live) self.live.textContent = (s === 'back' ? self.L('back') : self.L('front')) + ': ' + self.data[self.current].title;
      });
    });

    on(r, 'keydown', function (e) {
      if (e.target.closest('input, select, textarea')) return;
      if (e.key === 'ArrowLeft') { e.preventDefault(); self.go(self.current - 1, true); self.focusCurrent(); }
      if (e.key === 'ArrowRight') { e.preventDefault(); self.go(self.current + 1, true); self.focusCurrent(); }
    });
    on(r, 'pointerenter', function (e) { if (e.pointerType === 'mouse') { self.hover = true; self.schedule(); } });
    on(r, 'pointerleave', function (e) { if (e.pointerType === 'mouse') { self.hover = false; self.schedule(); } });
    on(r, 'focusin', function () { self.focusWithin = true; self.schedule(); });
    on(r, 'focusout', function (e) { if (!r.contains(e.relatedTarget)) { self.focusWithin = false; self.schedule(); } });

    var sx = 0, sy = 0, active = false, decided = false, horizontal = false, pid = null;
    on(this.stage, 'pointerdown', function (e) {
      if (e.button !== 0) return;
      active = true; decided = false; horizontal = false; sx = e.clientX; sy = e.clientY; pid = e.pointerId;
      self.suppressClick = false;
    });
    on(this.stage, 'pointermove', function (e) {
      if (!active || e.pointerId !== pid) return;
      var dx = e.clientX - sx, dy = e.clientY - sy;
      if (!decided && (Math.abs(dx) > 8 || Math.abs(dy) > 8)) {
        decided = true; horizontal = Math.abs(dx) > Math.abs(dy) * 1.2;
        if (horizontal) {
          self.dragging = true; r.classList.add('is-dragging'); self.schedule();
          try { self.stage.setPointerCapture(pid); } catch (err) {}
        }
      }
      if (horizontal) self.layout(dx * 0.35);
    });
    var end = function (e) {
      if (!active || (e && e.pointerId !== pid)) return;
      active = false;
      if (!horizontal) return;
      var dx = e.clientX - sx;
      self.dragging = false; r.classList.remove('is-dragging');
      self.suppressClick = true; setTimeout(function () { self.suppressClick = false; }, 60);
      var th = Math.min(70, self.stageW * 0.12);
      if (dx < -th) self.go(self.current + 1, true);
      else if (dx > th) self.go(self.current - 1, true);
      else { self.layout(); self.schedule(); }
    };
    on(this.stage, 'pointerup', end);
    on(this.stage, 'pointercancel', end);

    if ('IntersectionObserver' in window) {
      this.io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          self.visible = en.isIntersecting && en.intersectionRatio >= 0.35;
          r.classList.toggle('is-offscreen', !en.isIntersecting);
          self.schedule();
        });
      }, { threshold: [0, 0.35, 0.6] });
      this.io.observe(r);
    } else { this.visible = true; }
    on(document, 'visibilitychange', function () { self.schedule(); });
    if ('ResizeObserver' in window) { this.ro = new ResizeObserver(function () { self.layout(); }); this.ro.observe(this.stage); }
    else on(window, 'resize', function () { self.layout(); });
    this.onMQ = function () { self.layout(); };
    listen(mobileMQ, this.onMQ); listen(tabletMQ, this.onMQ);
    listen(reduceMQ, function () { if (reduceMQ.matches) self.userPaused = true; self.schedule(); });
  };

  Motion.prototype.destroy = function () {
    clearTimeout(this.timer); clearTimeout(this.infoT);
    if (this.ac) this.ac.abort();
    if (this.io) this.io.disconnect();
    if (this.ro) this.ro.disconnect();
    this.root.__scCM = null;
  };

  Motion.prototype.rel = function (i) {
    var n = this.n, d = ((i - this.current) % n + n) % n;
    if (d > n / 2) d -= n;
    return d;
  };

  Motion.prototype.layout = function (dragPx) {
    var cfg = SLOTS[mobileMQ.matches ? 'mobile' : (tabletMQ.matches ? 'tablet' : 'desktop')];
    this.stageW = this.stage.clientWidth || 1;
    this.stageH = this.stage.clientHeight || 1;
    var self = this, maxW = this.stageW * (mobileMQ.matches ? 0.74 : 0.5);
    this.items.forEach(function (a, i) {
      /* 2026-10-12: con 6+ capi la distanza 3 ha uno slot proprio, invisibile (niente sovrapposizioni) */
      var p = self.data[i], d = self.rel(i), ad = Math.min(Math.abs(d), cfg.slots.length - 1), slot = cfg.slots[ad];
      var h = self.stageH * cfg.fit * p.height, w = Math.min(h * p.ratio, maxW);
      var x = (d === 0 ? 0 : (d > 0 ? 1 : -1)) * slot.x * self.stageW + (dragPx || 0);
      var realH = (w / p.ratio) * slot.s;
      var y = Math.max(0, (self.stageH - realH) / 2 - self.stageH * 0.02);
      a.style.setProperty('--w', w.toFixed(1) + 'px');
      a.style.setProperty('--x', x.toFixed(1) + 'px');
      a.style.setProperty('--y', y.toFixed(1) + 'px');
      a.style.setProperty('--s', slot.s);
      a.style.setProperty('--o', slot.o);
      a.style.setProperty('--z', 10 - ad);
      a.style.setProperty('--td', (ad * 55) + 'ms');
      a.setAttribute('data-pos', d);
      var hidden = slot.o === 0;
      a.setAttribute('aria-hidden', hidden ? 'true' : 'false');
      a.tabIndex = hidden ? -1 : 0;
      a.setAttribute('aria-label', (d === 0 ? self.L('open') : self.L('show')) + p.title);
    });
  };

  Motion.prototype.go = function (i, manual) {
    var next = ((i % this.n) + this.n) % this.n;
    if (next === this.current && !manual) return;
    this.current = next;
    this.side = 'front';
    this.layout();
    this.render(false);
    if (manual) { this.announce(); this.restartTimer(); }
  };

  Motion.prototype.focusCurrent = function () {
    var a = this.items[this.current];
    if (a && this.stage.contains(document.activeElement)) a.focus({ preventScroll: true });
  };

  Motion.prototype.render = function (initial) {
    this.renderInfo(!initial);
    this.renderSide();
    var c = pad(this.current + 1) + ' / ' + pad(this.n);
    Array.prototype.forEach.call(this.countEls, function (e) { e.textContent = c; });
  };

  Motion.prototype.renderInfo = function (animate) {
    var p = this.data[this.current], info = this.info, self = this;
    if (!info) return;
    var write = function () {
      info.querySelector('[data-cm-meta]').textContent = p.meta;
      info.querySelector('[data-cm-name]').textContent = p.title;
      info.querySelector('[data-cm-price]').textContent = p.price;
      var cta = info.querySelector('[data-cm-cta]');
      cta.href = p.url;
      cta.setAttribute('aria-label', self.L('cta') + ': ' + p.title);
      if (self.sides) self.sides.hidden = !p.back;
      info.classList.remove('is-swapping');
    };
    clearTimeout(this.infoT);
    if (!animate || reduceMQ.matches) { write(); return; }
    info.classList.add('is-swapping');
    this.infoT = setTimeout(write, 260);
  };

  Motion.prototype.renderSide = function () {
    var cur = this.current, side = this.side;
    this.items.forEach(function (a, i) { a.classList.toggle('show-back', i === cur && side === 'back'); });
    Array.prototype.forEach.call(this.sideBtns, function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-side') === side ? 'true' : 'false'); });
  };

  Motion.prototype.announce = function () {
    if (!this.live) return;
    var p = this.data[this.current];
    this.live.textContent = p.title + ', ' + p.price + '. ' + (this.current + 1) + ' ' + this.L('of') + ' ' + this.n + '.';
  };

  Motion.prototype.canPlay = function () {
    return !this.userPaused && !this.editorHold && this.visible && !document.hidden && !this.hover && !this.focusWithin && !this.dragging;
  };

  Motion.prototype.restartTimer = function () {
    this.remaining = this.interval;
    if (this.progress) { this.root.classList.remove('is-playing'); void this.progress.offsetWidth; }
    if (this.timer) { clearTimeout(this.timer); this.timer = null; }
    this.schedule();
  };

  Motion.prototype.schedule = function () {
    var self = this, play = this.canPlay();
    this.root.classList.toggle('is-paused', !play);
    if (this.playBtn) {
      this.playBtn.innerHTML = this.userPaused ? ICON_PLAY : ICON_PAUSE;
      this.playBtn.setAttribute('aria-label', this.userPaused ? this.L('play') : this.L('pause'));
      this.playBtn.setAttribute('aria-pressed', this.userPaused ? 'false' : 'true');
    }
    if (this.timer) {
      clearTimeout(this.timer); this.timer = null;
      this.remaining = Math.max(400, this.remaining - (Date.now() - this.startedAt));
    }
    if (this.userPaused) { this.root.classList.remove('is-playing'); this.remaining = this.interval; return; }
    if (!play) return;
    this.root.classList.add('is-playing');
    this.startedAt = Date.now();
    this.timer = setTimeout(function () {
      self.timer = null;
      self.remaining = self.interval;
      self.go(self.current + 1, false);
      if (self.progress) { self.root.classList.remove('is-playing'); void self.progress.offsetWidth; }
      self.schedule();
    }, this.remaining);
  };

  function init(scope) {
    (scope || document).querySelectorAll('[data-sc-cm]').forEach(function (r) { if (!r.__scCM) new Motion(r); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();

  /* Theme editor */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    e.target.querySelectorAll('[data-sc-cm]').forEach(function (r) { if (r.__scCM) r.__scCM.destroy(); });
  });
  document.addEventListener('shopify:block:select', function (e) {
    var item = e.target.closest ? e.target.closest('.sc-cm__item') : null;
    var root = item && item.closest('[data-sc-cm]');
    if (!root || !root.__scCM) return;
    var m = root.__scCM; m.editorHold = true; m.go(m.items.indexOf(item), true);
  });
  document.addEventListener('shopify:block:deselect', function (e) {
    var root = e.target.closest ? e.target.closest('[data-sc-cm]') : null;
    if (root && root.__scCM) { root.__scCM.editorHold = false; root.__scCM.schedule(); }
  });
})();
